import cx from 'clsx';

import { Text } from '~components';
import { iEvent } from '~models';

import $ from './event-select.scss';

interface iProps {
    event: iEvent;
    updateEvent: (event: iEvent) => void;
    active?: boolean;
    showImage?: boolean;
}

export function EventSelect({ event, active, updateEvent, showImage }: iProps): JSX.Element {
    const imageSrc = showImage ? (event.channelImageLight ?? undefined) : undefined;
    const shouldShowImage = Boolean(imageSrc);
    return (
        <div
            className={cx($.container, active && $.active)}
            onClick={() => updateEvent(event)}
            onKeyPress={() => updateEvent(event)}
            role='button'
            tabIndex={0}
        >
            {shouldShowImage && (
                <img className={$.logo} src={imageSrc} alt={event.channelName} height={24} />
            )}
            {!shouldShowImage && <Text className={$.name}>{event.channelName}</Text>}
        </div>
    );
}
